import { render, staticRenderFns } from "./versionControl.vue?vue&type=template&id=29068ce6&"
import script from "./versionControl.vue?vue&type=script&lang=js&"
export * from "./versionControl.vue?vue&type=script&lang=js&"
import style0 from "./versionControl.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports